/**
 * Uebersetzungen. Bewusst als flache Objekte mit Punkt-Keys --
 * das laesst sich mit Grep vollstaendig pruefen und braucht keine
 * i18n-Bibliothek.
 *
 * `{platzhalter}` wird zur Laufzeit ersetzt.
 */

export const de = {
  'app.title': 'Hitster Digital',
  'app.tagline': 'Das Musik-Zeitreise-Spiel mit deinen eigenen Spotify-Playlists',

  // --- Allgemein ---
  'common.back': 'Zurück',
  'common.cancel': 'Abbrechen',
  'common.confirm': 'Bestätigen',
  'common.close': 'Schließen',
  'common.loading': 'Lädt…',
  'common.save': 'Speichern',
  'common.yes': 'Ja',
  'common.no': 'Nein',
  'common.you': 'Du',
  'common.host': 'Host',
  'common.copy': 'Kopieren',
  'common.copied': 'Kopiert!',
  'common.retry': 'Erneut versuchen',
  'common.year': 'Jahr',
  'common.of': 'von',

  // --- Startseite ---
  'home.hostGame': 'Spiel hosten',
  'home.hostGameHint': 'Du wählst die Playlist und startest die Runde',
  'home.joinGame': 'Spiel beitreten',
  'home.joinGameHint': 'Du hast einen 4-stelligen Raumcode',
  'home.yourName': 'Dein Name',
  'home.namePlaceholder': 'z.B. Nico',
  'home.roomCode': 'Raumcode',
  'home.create': 'Raum erstellen',
  'home.join': 'Beitreten',
  'home.spotifyRequired': 'Zum Hosten brauchst du ein verbundenes Spotify-Konto.',
  'home.rulesLink': 'Spielregeln',

  // --- Spotify ---
  'spotify.connect': 'Mit Spotify verbinden',
  'spotify.connected': 'Verbunden als {name}',
  'spotify.disconnect': 'Trennen',
  'spotify.premiumRequired': 'Spotify Premium erforderlich',
  'spotify.premiumExplain':
    'Das Abspielen im Browser funktioniert nur mit Spotify Premium. Ohne Premium kannst du mitspielen, aber keinen Ton ausgeben.',
  'spotify.notPremium': 'Kein Premium ({product})',
  'spotify.denied': 'Du hast den Spotify-Zugriff abgelehnt.',
  'spotify.expired': 'Die Anmeldung ist abgelaufen. Bitte erneut versuchen.',
  'spotify.failed': 'Die Spotify-Anmeldung ist fehlgeschlagen.',
  'spotify.sessionMismatch': 'Sitzung passte nicht. Bitte erneut anmelden.',
'spotify.refreshProfile': 'Profil neu laden',
  'spotify.missingScopes': 'Spotify hat nicht alle Berechtigungen erteilt',
  'spotify.missingScopesFix':
    'Deshalb schlagen manche Spotify-Zugriffe fehl (z.B. das Laden von Playlist-Songs). Ursache: Die App wurde schon einmal mit weniger Rechten autorisiert. Entferne "Hitster Digital" in deinen Spotify-Kontoeinstellungen und verbinde dann neu.',
  'spotify.openAppSettings': 'Spotify-Kontoeinstellungen öffnen',
  'spotify.reconnect': 'Trennen und neu verbinden',

  // --- Lobby ---
  'lobby.title': 'Lobby',
  'lobby.joinWith': 'Beitreten unter',
  'lobby.code': 'Code',
  'lobby.players': 'Spieler',
  'screen.log': 'Verlauf',
  'lobby.waitingForHost': 'Warte auf den Host…',
  'lobby.start': 'Spiel starten',
  'lobby.needPlaylist': 'Wähle zuerst eine Playlist.',
  'lobby.needTracks': 'Die Playlist hat zu wenige spielbare Songs (mindestens {min}).',
  'lobby.kick': 'Entfernen',
  'lobby.scanQr': 'QR-Code scannen oder Code eingeben',

  // --- Playlist ---
  'playlist.title': 'Playlist',
  'playlist.yourPlaylists': 'Deine Playlists',
  'playlist.paste': 'Spotify-Link einfügen',
  'playlist.pastePlaceholder': 'https://open.spotify.com/playlist/…',
  'playlist.load': 'Laden',
  'playlist.selected': 'Ausgewählt',
  'playlist.tracks': '{count} Songs',
  'playlist.usable': '{usable} von {total} Songs nutzbar',
  'playlist.reload': 'Playlists neu laden',
  'playlist.refresh': 'Liste aktualisieren',
  'playlist.showMine': 'Meine Playlists anzeigen',
  'playlist.showMineHint':
    'Das Auflisten kostet mehrere Spotify-Anfragen. Mit einem Link geht es sparsamer.',
  'playlist.empty': 'Keine Playlists gefunden.',
  'playlist.ownOnly':
    'Nur eigene Playlists — Spotify sperrt fremde für diese App. Willst du eine andere spielen, öffne sie in Spotify, markiere alle Songs und lege sie über „Zu Playlist hinzufügen" in eine eigene Playlist.',
  'playlist.limitedAccess':
    'Spotify hat den regulären Zugriff auf diese Playlist gesperrt. Die Songs wurden über einen Notweg geladen — dabei sind maximal 100 Songs erreichbar. Bei größeren Playlists fehlt der Rest.',
  'playlist.staleCache':
    'Spotifys Anfragelimit ist erschöpft. Gespielt wird mit der zuletzt gespeicherten Fassung dieser Playlist ({minutes} min alt) — Songs, die du seitdem hinzugefügt hast, fehlen.',
  'playlist.enriching': 'Erscheinungsjahre werden geprüft: {resolved}/{total}',
  'playlist.enrichDone': 'Alle Erscheinungsjahre geprüft',
  'playlist.enrichHint':
    'Die Jahre werden über MusicBrainz korrigiert, weil Spotify bei Remastern falsche Daten liefert. Das Spiel kann sofort starten — die Prüfung läuft im Hintergrund weiter.',

  // --- Einstellungen ---
  'settings.title': 'Regeln',
  'settings.targetCards': 'Karten zum Sieg',
  'settings.maxTokens': 'Maximale Token',
  'settings.allowSteal': 'Klauen erlaubt',
  'settings.allowStealHint': 'Andere dürfen einen Token einsetzen, um eine falsche Karte zu holen',
  'settings.allowSkip': 'Überspringen erlaubt',
  'settings.allowSkipHint': 'Ein Token gegen einen neuen Song tauschen',
  'settings.allowGuess': 'Titel & Interpret raten',
  'settings.guessChoice': 'Raten als Auswahl (leichter)',
  'settings.guessChoiceHint':
    'Vier Vorschläge aus der Playlist, einer ist richtig. Deutlich leichter als frei tippen — gut für Kinder oder gemischte Runden.',
  'settings.allowGuessHint': 'Beides richtig bringt einen Token',
  'settings.verifiedYear': 'Nur geprüfte Erscheinungsjahre',
  'settings.verifiedYearHint':
    'Wertet nur Songs, deren Jahr über MusicBrainz belegt ist. Spotifys Album-Datum liegt bei Remastern oft Jahrzehnte daneben. Nicht belegbare Songs werden kostenlos ausgetauscht. Beim ersten Spiel mit einer neuen Playlist dauert das kurz.',
  'settings.placementTime': 'Zeit zum Platzieren (Sek., 0 = kein Limit)',
  'settings.stealWindow': 'Klau-Fenster (Sek.)',
  'settings.startAt': 'Song startet ab (Sek.)',
  'settings.startAtHint': 'Überspringt Intros, die man auswendig kennt',
  'settings.autoAdvance': 'Automatisch weiter',
  'settings.autoAdvanceHint': 'Nach dem Aufdecken selbstständig zum nächsten Spieler',
  'settings.autoAdvanceDelay': 'Wartezeit nach dem Aufdecken (Sek.)',
  'settings.lockedDuringGame': 'Regeln lassen sich nur in der Lobby ändern.',
  'settings.more': 'Mehr Einstellungen',

  // --- Lautsprecher ---
  'audio.title': 'Lautsprecher',
  'audio.explain':
    'Auf diesem Gerät Musik abspielen. Für Remote-Play schaltet jeder seinen eigenen Lautsprecher an.',
  'audio.enable': 'Ton auf diesem Gerät',
  'audio.disable': 'Ton ausschalten',
  'audio.active': 'Dieses Gerät spielt',
  'audio.inactive': 'Stumm',
  'audio.count': '{count} Gerät(e) spielen',
  'audio.none': 'Kein Lautsprecher aktiv — niemand hört Musik!',
  'audio.mobileUnsupported':
    'Mobile Browser können keine Musik abspielen (Spotify-Einschränkung). Nutze einen Desktop-Browser als Lautsprecher.',
  'audio.needSpotify': 'Verbinde erst dein Spotify-Konto.',
  'audio.initializing': 'Player wird gestartet…',
  'audio.error': 'Player-Fehler: {message}',
  'audio.volume': 'Lautstärke',
  'audio.tickSound': 'Ticken beim Jahr aufdecken',
  'audio.mute': 'Stumm schalten',
  'audio.unmute': 'Ton einschalten',
  'audio.cheatWarning':
    'Achtung: Wer den Ton ausgibt, sieht den Songtitel in seinen anderen Spotify-Apps.',

  // --- Spiel ---
  'game.turnOf': '{name} ist am Zug',
  'game.yourTurn': 'Du bist am Zug!',
  'game.actingFor': 'Du legst für {name} — reiche das Gerät weiter oder lege für ihn.',
  'game.listening': 'Song läuft…',
  'game.placePrompt': 'Wo gehört dieser Song in deine Zeitleiste?',
  'game.placeHere': 'Hier',
  'game.beforeAll': 'Ganz früh',
  'game.afterAll': 'Ganz spät',
  'game.confirmPlacement': 'Platzierung bestätigen',
  'game.placementSet': 'Platzierung gewählt — noch nicht bestätigt',
  'game.skip': 'Song überspringen (1 Token)',
  'game.replay': 'Nochmal',
  'game.replayHint': 'Spielt den aktuellen Song von vorn.',
  'game.checkingYear': 'Prüfe Erscheinungsjahr…',
  'game.guessTitle': 'Titel',
  'game.guessArtist': 'Interpret',
  'game.guessSubmit': 'Tipp abgeben',
  'game.guessHint': 'Titel UND Interpret richtig = 1 Token',
  'game.guessSubmitted': 'Tipp abgegeben',
  'game.waitingForPlacement': 'Warte auf {name}…',
  'game.deckRemaining': '{count} Karten im Deck',
  'game.tokens': 'Token',
  'game.timeline': 'Zeitleiste',
  'game.timelineEmpty': 'Noch keine Karte',
  'game.showTimelineOf': 'Zeitleiste von {name} anzeigen',
  'game.cards': '{count}/{target} Karten',

  // --- Klauen ---
  'steal.window': 'Klauen möglich!',
  'steal.timeLeft': 'Noch Zeit',
  'steal.explain': '{name} hat platziert. Glaubst du, das ist falsch?',
  'steal.claim': 'Klauen (1 Token)',
  'steal.claimAt': 'Hier klauen',
  'steal.pass': 'Passen',
  'steal.claimed': 'Du hast geklaut',
  'steal.passed': 'Du hast gepasst',
  'steal.noTokens': 'Du hast keine Token',
  'steal.someoneClaimed': '{name} versucht zu klauen',
  'steal.waiting': 'Warte auf die anderen…',

  // --- Aufdecken ---
  'reveal.correct': 'Richtig!',
  'reveal.wrong': 'Falsch!',
  'reveal.year': 'Erschienen {year}',
  'reveal.cardTo': 'Karte geht an {name}',
  'reveal.discarded': 'Karte wird abgelegt',
  'reveal.stealWon': '{name} hat die Karte geklaut!',
  'reveal.stealFailed': '{name} hat sich verklaut',
  'reveal.stealWasted': '{name} hat den Token umsonst gesetzt',
  'reveal.guessBoth': 'Titel & Interpret richtig — 1 Token!',
  'reveal.guessTitleOnly': 'Nur der Titel war richtig',
  'reveal.guessArtistOnly': 'Nur der Interpret war richtig',
  'reveal.guessWrong': 'Tipp war falsch',
  'reveal.next': 'Weiter',
  'reveal.yearSourceSpotify': 'Achtung: Jahr nur laut Spotify — bei Remastern oft zu spät',
  'reveal.yearSourceMusicbrainz': 'Jahr laut MusicBrainz',
  'reveal.yearSourceManual': 'Jahr manuell gesetzt',

  // --- Mediathek ---
  'like.add': 'Merken',
  'like.saved': 'Gemerkt',
  'like.remove': 'Aus der Mediathek entfernen',
  'like.failed': 'Konnte nicht gespeichert werden. Spotify eventuell neu verbinden.',

  // --- Ende ---
  'finished.title': 'Spiel vorbei!',
  'finished.winner': '{name} gewinnt!',
  'finished.winners': 'Gewinner: {names}',
  'finished.restart': 'Neues Spiel',
  'finished.backToLobby': 'Zurück zur Lobby',

  // --- Ansicht ---
  'view.screen': 'TV-Ansicht',
  'view.controls': 'Steuerung',
  'view.screenHint': 'Diese Ansicht auf den großen Bildschirm — Spieler steuern per Handy.',

  // --- Zuschauer und lokale Mitspieler ---
  'role.playAlong': 'Ich spiele mit',
  'role.playingHint': 'Du bekommst eine Zeitleiste und kommst an die Reihe.',
  'role.spectatingHint':
    'Du schaust nur zu: kein Spielplatz, kein Zug. Ton ausgeben und die Runde leiten geht trotzdem.',
  'spectator.title': 'Zuschauer',
  'spectator.join': 'Nur zuschauen',
  'spectator.joinHint':
    'Kein Spielplatz, kein Zug. Ideal für den Rechner am Fernseher: große Ansicht zeigen und den Ton ausgeben, ohne selbst mitzuspielen.',
  'spectator.youAre': 'Du schaust zu. Du kannst den Ton ausgeben, spielst aber nicht mit.',
  'local.title': 'Mitspieler an diesem Gerät',
  'local.explain':
    'Für alle, die kein eigenes Handy nutzen. Sie bekommen einen vollwertigen Platz, du legst für sie. Lässt sich mit Mitspielern am Handy mischen.',
  'local.add': 'Hinzufügen',
  'local.namePlaceholder': 'Name',
  'local.badge': 'Am Host-Gerät',
  'local.lobbyOnly': 'Mitspieler lassen sich nur in der Lobby hinzufügen.',

  // --- Raum-Menue ---
  'menu.title': 'Menü',
  'menu.abortGame': 'Spiel abbrechen',
  'menu.leaveRoom': 'Raum verlassen',
  'menu.leaveHint': 'Du kannst später mit demselben Code wieder beitreten.',
  'menu.hostLeaveHint': 'Als Host gibst du die Host-Rolle an einen Mitspieler ab.',
  'menu.confirmAbort': 'Laufendes Spiel abbrechen und zurück in die Lobby?',
  'menu.confirmLeave': 'Wirklich den Raum verlassen?',

  // --- Log ---
  'log.playerJoined': '{name} ist beigetreten',
  'log.playerLeft': '{name} hat die Verbindung verloren',
  'log.playerKicked': '{name} wurde entfernt',
  'log.playlistSelected': 'Playlist "{name}" geladen ({count} Songs)',
  'log.gameStarted': 'Das Spiel beginnt!',
  'log.gameFinished': 'Spiel vorbei — {names}',
  'log.skipped': '{name} hat den Song übersprungen',
  'log.stealClaimed': '{name} will klauen',
  'log.placementCorrect': '{name} lag richtig ({year})',
  'log.placementWrong': '{name} lag falsch ({year})',
  'log.speakerAdded': '{name} gibt jetzt Ton aus',
  'log.hostChanged': '{name} ist jetzt Host',
  'log.spectatorJoined': '{name} schaut zu',
  'log.localPlayerAdded': '{name} spielt am Host-Gerät mit',
  'log.nowPlaying': '{name} spielt mit',
  'log.nowSpectating': '{name} schaut nur noch zu',
  'log.gameAborted': 'Das Spiel wurde abgebrochen',

  // --- Fehler ---
  'error.not_your_turn': 'Du bist nicht am Zug.',
  'error.wrong_phase': 'Das geht in dieser Spielphase nicht.',
  'error.player_not_found': 'Spieler nicht gefunden.',
  'error.not_host': 'Nur der Host darf das.',
  'error.no_playlist': 'Es ist keine Playlist ausgewählt.',
  'error.not_enough_tracks': 'Die Playlist hat zu wenige spielbare Songs.',
  'error.not_enough_players': 'Es fehlen Spieler.',
  'error.invalid_slot': 'Ungültige Position.',
  'error.no_placement': 'Wähle zuerst eine Position.',
  'error.no_tokens': 'Du hast keine Token mehr.',
  'error.skip_disabled': 'Überspringen ist ausgeschaltet.',
  'error.steal_disabled': 'Klauen ist ausgeschaltet.',
  'error.already_claimed': 'Du hast schon geklaut.',
  'error.cannot_steal_own_turn': 'Beim eigenen Zug kann man nicht klauen.',
  'error.guess_already_submitted': 'Du hast schon geraten.',
  'error.guess_disabled': 'Raten ist ausgeschaltet.',
  'error.deck_empty': 'Das Deck ist leer.',
  'error.game_over': 'Das Spiel ist vorbei.',
  'error.room_not_found': 'Raum nicht gefunden.',
  'error.room_full': 'Der Raum ist voll.',
  'error.name_taken': 'Der Name ist schon vergeben.',
  'error.invalid_name': 'Bitte einen Namen mit 1–20 Zeichen wählen.',
  'error.not_authenticated': 'Du musst dein Spotify-Konto verbinden.',
  'error.spotify_error': 'Spotify hat einen Fehler gemeldet.',
  'error.premium_required': 'Dafür braucht es Spotify Premium.',
  'error.playlist_not_found': 'Playlist nicht gefunden oder nicht zugänglich.',
  'error.playlist_empty': 'Die Playlist enthält keine spielbaren Songs.',
  'error.spotify_reauth_required':
    'Dem Spotify-Zugang fehlen Berechtigungen. Klicke bei „Spotify" auf „Trennen und neu verbinden" — danach funktioniert das Laden der Playlist.',
  'error.spotify_library_unavailable':
    'Spotify erlaubt dieser App keinen Zugriff auf deine Mediathek (Development Mode). Neu-Verbinden hilft nicht — dafür braucht es den Extended Quota Mode im Spotify-Dashboard. Der Merken-Knopf wird ausgeblendet.',
  'error.playlist_forbidden':
    'Spotify gibt den Inhalt dieser Playlist nicht heraus. Apps im Development Mode dürfen nur EIGENE Playlists lesen. Lösung: In Spotify die Playlist öffnen, alle Songs markieren, „Zu Playlist hinzufügen" → neue eigene Playlist. Die ist dann uneingeschränkt spielbar.',
  'error.rate_limited': 'Zu viele Anfragen an Spotify. Kurz warten.',
  'error.request_timeout':
    'Der Server hat nicht geantwortet. Prüfe die Verbindung und versuche es erneut.',
  'error.spotify_forbidden':
    'Spotify hat den Zugriff verweigert. Meist fehlen Berechtigungen: Spotify trennen und neu verbinden.',
  'error.playback_failed': 'Wiedergabe fehlgeschlagen.',
  'error.audio_device_lost': 'Das Abspielgeraet ist verschwunden. Ton bitte neu einschalten.',
  'error.internal_error': 'Unerwarteter Serverfehler.',
  'error.disconnected': 'Verbindung verloren. Verbinde neu…',
  'error.roomClosed': 'Der Raum wurde geschlossen.',

  // --- Regeln ---
  'rules.title': 'So geht Hitster',
  'rules.goal': 'Ziel: Sammle als Erster {target} Karten in deiner Zeitleiste.',
  'rules.step1':
    'Du bist am Zug: Ein Song wird gespielt, du weißt nicht welcher. Ordne ihn chronologisch in deine Zeitleiste ein.',
  'rules.step2':
    'Optional: Rate Titel und Interpret. Sind beide richtig, bekommst du einen Token.',
  'rules.step3':
    'Bestätige die Position. Danach dürfen die anderen einen Token einsetzen, um zu klauen — falls sie glauben, du liegst falsch.',
  'rules.step4':
    'Aufdecken: Lag deine Karte richtig, behältst du sie. Sonst hat der Klauende die Chance, sie zu bekommen.',
  'rules.step5': 'Token kannst du auch einsetzen, um einen Song zu überspringen.',
} as const;

export type TranslationKey = keyof typeof de;

export const en: Record<TranslationKey, string> = {
  'app.title': 'Hitster Digital',
  'app.tagline': 'The music timeline game with your own Spotify playlists',

  'common.back': 'Back',
  'common.cancel': 'Cancel',
  'common.confirm': 'Confirm',
  'common.close': 'Close',
  'common.loading': 'Loading…',
  'common.save': 'Save',
  'common.yes': 'Yes',
  'common.no': 'No',
  'common.you': 'You',
  'common.host': 'Host',
  'common.copy': 'Copy',
  'common.copied': 'Copied!',
  'common.retry': 'Try again',
  'common.year': 'Year',
  'common.of': 'of',

  'home.hostGame': 'Host a game',
  'home.hostGameHint': 'You pick the playlist and start the round',
  'home.joinGame': 'Join a game',
  'home.joinGameHint': 'You have a 4-character room code',
  'home.yourName': 'Your name',
  'home.namePlaceholder': 'e.g. Nico',
  'home.roomCode': 'Room code',
  'home.create': 'Create room',
  'home.join': 'Join',
  'home.spotifyRequired': 'You need a linked Spotify account to host.',
  'home.rulesLink': 'How to play',

  'spotify.connect': 'Connect Spotify',
  'spotify.connected': 'Connected as {name}',
  'spotify.disconnect': 'Disconnect',
  'spotify.premiumRequired': 'Spotify Premium required',
  'spotify.premiumExplain':
    'In-browser playback only works with Spotify Premium. Without it you can still play, but cannot output audio.',
  'spotify.notPremium': 'No Premium ({product})',
  'spotify.denied': 'You denied Spotify access.',
  'spotify.expired': 'The login expired. Please try again.',
  'spotify.failed': 'Spotify login failed.',
  'spotify.sessionMismatch': 'Session mismatch. Please sign in again.',
'spotify.refreshProfile': 'Reload profile',
  'spotify.missingScopes': 'Spotify did not grant all permissions',
  'spotify.missingScopesFix':
    'That makes some Spotify calls fail (for example loading playlist songs). Cause: the app was authorized earlier with fewer permissions. Remove "Hitster Digital" in your Spotify account settings, then reconnect.',
  'spotify.openAppSettings': 'Open Spotify account settings',
  'spotify.reconnect': 'Disconnect and reconnect',

  'lobby.title': 'Lobby',
  'lobby.joinWith': 'Join at',
  'lobby.code': 'Code',
  'lobby.players': 'Players',
  'screen.log': 'History',
  'lobby.waitingForHost': 'Waiting for the host…',
  'lobby.start': 'Start game',
  'lobby.needPlaylist': 'Pick a playlist first.',
  'lobby.needTracks': 'The playlist has too few playable songs (at least {min}).',
  'lobby.kick': 'Remove',
  'lobby.scanQr': 'Scan the QR code or enter the code',

  'playlist.title': 'Playlist',
  'playlist.yourPlaylists': 'Your playlists',
  'playlist.paste': 'Paste a Spotify link',
  'playlist.pastePlaceholder': 'https://open.spotify.com/playlist/…',
  'playlist.load': 'Load',
  'playlist.selected': 'Selected',
  'playlist.tracks': '{count} songs',
  'playlist.usable': '{usable} of {total} songs usable',
  'playlist.reload': 'Reload playlists',
  'playlist.refresh': 'Refresh list',
  'playlist.showMine': 'Show my playlists',
  'playlist.showMineHint':
    'Listing costs several Spotify requests. A link is cheaper.',
  'playlist.empty': 'No playlists found.',
  'playlist.ownOnly':
    'Your own playlists only — Spotify blocks other people\u2019s for this app. To play a different one, open it in Spotify, select all songs and use "Add to playlist" to copy them into a playlist of your own.',
  'playlist.limitedAccess':
    'Spotify blocked regular access to this playlist. The songs were loaded through a fallback that reaches at most 100 songs. Anything beyond that is missing.',
  'playlist.staleCache':
    'Spotify request limit reached. Playing from the last stored copy of this playlist ({minutes} min old) — songs you added since then are missing.',
  'playlist.enriching': 'Verifying release years: {resolved}/{total}',
  'playlist.enrichDone': 'All release years verified',
  'playlist.enrichHint':
    'Years are corrected via MusicBrainz because Spotify reports remaster dates. You can start right away — verification continues in the background.',

  'settings.title': 'Rules',
  'settings.targetCards': 'Cards to win',
  'settings.maxTokens': 'Maximum tokens',
  'settings.allowSteal': 'Stealing allowed',
  'settings.allowStealHint': 'Others may spend a token to grab a wrongly placed card',
  'settings.allowSkip': 'Skipping allowed',
  'settings.allowSkipHint': 'Trade a token for a new song',
  'settings.allowGuess': 'Guess title & artist',
  'settings.guessChoice': 'Guessing as multiple choice (easier)',
  'settings.guessChoiceHint':
    'Four suggestions from the playlist, one is correct. Much easier than typing — good for kids or mixed groups.',
  'settings.allowGuessHint': 'Both correct earns a token',
'settings.verifiedYear': 'Verified release years only',
  'settings.verifiedYearHint':
    'Only scores songs whose year is confirmed via MusicBrainz. Spotify album dates are often decades off for remasters. Unconfirmable songs are swapped out for free. Takes a moment on the first game with a new playlist.',
  'settings.placementTime': 'Time to place (sec, 0 = no limit)',
  'settings.stealWindow': 'Steal window (sec)',
  'settings.startAt': 'Song starts at (sec)',
  'settings.startAtHint': 'Skips intros everybody knows by heart',
  'settings.autoAdvance': 'Auto-advance',
  'settings.autoAdvanceHint': 'Move to the next player automatically after the reveal',
  'settings.autoAdvanceDelay': 'Delay after reveal (sec)',
  'settings.lockedDuringGame': 'Rules can only be changed in the lobby.',
  'settings.more': 'More settings',

  'audio.title': 'Speaker',
  'audio.explain':
    'Play music on this device. For remote play everyone turns on their own speaker.',
  'audio.enable': 'Audio on this device',
  'audio.disable': 'Turn audio off',
  'audio.active': 'This device is playing',
  'audio.inactive': 'Muted',
  'audio.count': '{count} device(s) playing',
  'audio.none': 'No speaker active — nobody hears music!',
  'audio.mobileUnsupported':
    'Mobile browsers cannot play music (Spotify limitation). Use a desktop browser as the speaker.',
  'audio.needSpotify': 'Connect your Spotify account first.',
  'audio.initializing': 'Starting player…',
  'audio.error': 'Player error: {message}',
  'audio.volume': 'Volume',
  'audio.tickSound': 'Ticking while the year counts',
  'audio.mute': 'Mute',
  'audio.unmute': 'Unmute',
  'audio.cheatWarning':
    'Heads up: whoever outputs audio can see the song title in their other Spotify apps.',

  'game.turnOf': "{name}'s turn",
  'game.yourTurn': "It's your turn!",
  'game.actingFor': 'You are placing for {name} — hand the device over or place for them.',
  'game.listening': 'Song playing…',
  'game.placePrompt': 'Where does this song belong in your timeline?',
  'game.placeHere': 'Here',
  'game.beforeAll': 'Earliest',
  'game.afterAll': 'Latest',
  'game.confirmPlacement': 'Confirm placement',
  'game.placementSet': 'Position chosen — not confirmed yet',
  'game.skip': 'Skip song (1 token)',
  'game.replay': 'Replay',
  'game.replayHint': 'Plays the current song from the start.',
  'game.checkingYear': 'Verifying release year…',
  'game.guessTitle': 'Title',
  'game.guessArtist': 'Artist',
  'game.guessSubmit': 'Submit guess',
  'game.guessHint': 'Title AND artist correct = 1 token',
  'game.guessSubmitted': 'Guess submitted',
  'game.waitingForPlacement': 'Waiting for {name}…',
  'game.deckRemaining': '{count} cards left',
  'game.tokens': 'Tokens',
  'game.timeline': 'Timeline',
  'game.timelineEmpty': 'No cards yet',
  'game.showTimelineOf': 'Show {name}\u2019s timeline',
  'game.cards': '{count}/{target} cards',

  'steal.window': 'Steal opportunity!',
  'steal.timeLeft': 'Time left',
  'steal.explain': '{name} placed the card. Think it is wrong?',
  'steal.claim': 'Steal (1 token)',
  'steal.claimAt': 'Steal here',
  'steal.pass': 'Pass',
  'steal.claimed': 'You are stealing',
  'steal.passed': 'You passed',
  'steal.noTokens': 'You have no tokens',
  'steal.someoneClaimed': '{name} is trying to steal',
  'steal.waiting': 'Waiting for the others…',

  'reveal.correct': 'Correct!',
  'reveal.wrong': 'Wrong!',
  'reveal.year': 'Released {year}',
  'reveal.cardTo': 'Card goes to {name}',
  'reveal.discarded': 'Card is discarded',
  'reveal.stealWon': '{name} stole the card!',
  'reveal.stealFailed': '{name} guessed wrong too',
  'reveal.stealWasted': '{name} wasted a token',
  'reveal.guessBoth': 'Title & artist correct — 1 token!',
  'reveal.guessTitleOnly': 'Only the title was right',
  'reveal.guessArtistOnly': 'Only the artist was right',
  'reveal.guessWrong': 'Guess was wrong',
  'reveal.next': 'Next',
  'reveal.yearSourceSpotify': 'Heads up: year per Spotify only — often too late for remasters',
  'reveal.yearSourceMusicbrainz': 'Year per MusicBrainz',
  'reveal.yearSourceManual': 'Year set manually',

  'like.add': 'Save',
  'like.saved': 'Saved',
  'like.remove': 'Remove from library',
  'like.failed': 'Could not save. You may need to reconnect Spotify.',
  'finished.title': 'Game over!',
  'finished.winner': '{name} wins!',
  'finished.winners': 'Winners: {names}',
  'finished.restart': 'New game',
  'finished.backToLobby': 'Back to lobby',

  'view.screen': 'TV view',
  'view.controls': 'Controls',
  'view.screenHint': 'Put this view on the big screen — players use their phones.',

  // --- Room menu ---
  'role.playAlong': 'I am playing',
  'role.playingHint': 'You get a timeline and take turns.',
  'role.spectatingHint':
    'You are only watching: no seat, no turn. You can still output audio and run the round.',
  'spectator.title': 'Spectators',
  'spectator.join': 'Just watch',
  'spectator.joinHint':
    'No seat, no turn. Ideal for the machine at the TV: show the big view and output the audio without playing along.',
  'spectator.youAre': 'You are spectating. You can output audio but do not play.',
  'local.title': 'Players on this device',
  'local.explain':
    'For everyone without their own phone. They get a full seat and you place for them. Can be mixed with players on phones.',
  'local.add': 'Add',
  'local.namePlaceholder': 'Name',
  'local.badge': 'On host device',
  'local.lobbyOnly': 'Players can only be added in the lobby.',

  'menu.title': 'Menu',
  'menu.abortGame': 'Abort game',
  'menu.leaveRoom': 'Leave room',
  'menu.leaveHint': 'You can rejoin later with the same code.',
  'menu.hostLeaveHint': 'As the host you hand the host role to another player.',
  'menu.confirmAbort': 'Abort the running game and return to the lobby?',
  'menu.confirmLeave': 'Really leave the room?',

  'log.playerJoined': '{name} joined',
  'log.playerLeft': '{name} lost connection',
  'log.playerKicked': '{name} was removed',
  'log.playlistSelected': 'Playlist "{name}" loaded ({count} songs)',
  'log.gameStarted': 'The game begins!',
  'log.gameFinished': 'Game over — {names}',
  'log.skipped': '{name} skipped the song',
  'log.stealClaimed': '{name} wants to steal',
  'log.placementCorrect': '{name} was right ({year})',
  'log.placementWrong': '{name} was wrong ({year})',
  'log.speakerAdded': '{name} is now the speaker',
  'log.hostChanged': '{name} is now the host',
  'log.spectatorJoined': '{name} is watching',
  'log.localPlayerAdded': '{name} plays on the host device',
  'log.nowPlaying': '{name} is playing along',
  'log.nowSpectating': '{name} is now only watching',
  'log.gameAborted': 'The game was aborted',

  'error.not_your_turn': 'It is not your turn.',
  'error.wrong_phase': 'Not possible in this phase.',
  'error.player_not_found': 'Player not found.',
  'error.not_host': 'Only the host can do that.',
  'error.no_playlist': 'No playlist selected.',
  'error.not_enough_tracks': 'The playlist has too few playable songs.',
  'error.not_enough_players': 'Not enough players.',
  'error.invalid_slot': 'Invalid position.',
  'error.no_placement': 'Choose a position first.',
  'error.no_tokens': 'You are out of tokens.',
  'error.skip_disabled': 'Skipping is disabled.',
  'error.steal_disabled': 'Stealing is disabled.',
  'error.already_claimed': 'You already claimed.',
  'error.cannot_steal_own_turn': 'You cannot steal on your own turn.',
  'error.guess_already_submitted': 'You already guessed.',
  'error.guess_disabled': 'Guessing is disabled.',
  'error.deck_empty': 'The deck is empty.',
  'error.game_over': 'The game is over.',
  'error.room_not_found': 'Room not found.',
  'error.room_full': 'The room is full.',
  'error.name_taken': 'That name is taken.',
  'error.invalid_name': 'Please pick a name with 1–20 characters.',
  'error.not_authenticated': 'You need to connect your Spotify account.',
  'error.spotify_error': 'Spotify reported an error.',
  'error.premium_required': 'This requires Spotify Premium.',
  'error.playlist_not_found': 'Playlist not found or not accessible.',
'error.playlist_empty': 'The playlist has no playable songs.',
  'error.spotify_reauth_required':
    'The Spotify connection is missing permissions. Use "Disconnect and reconnect" in the Spotify section — loading the playlist will work afterwards.',
  'error.spotify_library_unavailable':
    'Spotify does not allow this app to access your library (development mode). Reconnecting will not help — this requires Extended Quota Mode in the Spotify dashboard. The save button is hidden.',
  'error.playlist_forbidden':
    'Spotify will not release the contents of this playlist. Apps in development mode may only read playlists you OWN. Fix: open the playlist in Spotify, select all songs, "Add to playlist" → a new playlist of your own. That one is fully playable.',
  'error.rate_limited': 'Too many Spotify requests. Wait a moment.',
  'error.request_timeout':
    'The server did not respond. Check your connection and try again.',
  'error.spotify_forbidden':
    'Spotify denied access. Usually a missing permission: disconnect Spotify and reconnect.',
  'error.playback_failed': 'Playback failed.',
  'error.audio_device_lost': 'The playback device disappeared. Please turn audio on again.',
  'error.internal_error': 'Unexpected server error.',
  'error.disconnected': 'Connection lost. Reconnecting…',
  'error.roomClosed': 'The room was closed.',

  'rules.title': 'How Hitster works',
  'rules.goal': 'Goal: be the first to collect {target} cards in your timeline.',
  'rules.step1':
    'Your turn: a song plays and you do not know which. Place it chronologically in your timeline.',
  'rules.step2': 'Optional: guess title and artist. Both correct earns you a token.',
  'rules.step3':
    'Confirm the position. Then the others may spend a token to steal — if they think you are wrong.',
  'rules.step4':
    'Reveal: if your placement was right, you keep the card. Otherwise the stealer gets a shot at it.',
  'rules.step5': 'You can also spend a token to skip a song.',
};

export const locales = { de, en } as const;
